module.exports = [
	{
		path: 'amazonPackageGlobal/:id',
		name: 'Amazon Package Global',
		component: () => import('@/pages/packages/amazon_package_global/amazon_package_global.vue'),
		meta: {
			label: 'Amazon Package Global Form',
			icon: 'view_quilt',
			description: '',
			disabled: true
		}
	},
	{
		path: 'amazonQcGlobal/:id',
		name: 'Amazon Qc Global',
		component: () => import('@/pages/packages/amazon_package_global/amazon_package_global_qc.vue'),
		meta: {
			label: 'Amazon Qc Global',
			icon: 'view_quilt',
			description: '',
			disabled: true
		}
	},
	{
		path: '/lagardere/packages/:id',
		name: 'Lagardere packager',
		component: () => import('@/pages/packages/lagardere/lagardere_packager.vue'),
		meta: {
			label: 'Lagardère packager',
			icon: 'view_quilt',
			description: '',
			disabled: true
		}
	},
	{
		path: '/lagardere/qc/:id',
		name: 'Lagardere QC',
		component: () => import('@/pages/packages/lagardere/lagardere_qc.vue'),
		meta: {
			label: 'Lagardère QC',
			icon: 'view_quilt',
			description: '',
			disabled: true
		}
	},
	{
		path: 'xbox_package/:id',
		name: 'Xbox Package',
		component: () => import('@/pages/packages/xbox/packager_xbox.vue'),
		meta: {
			label: 'Package Xbox',
			icon: 'play_arrow',
			description: `Packager xbox à la norme Movielabs`,
			disabled: true
		}
	},
	{
		path: 'xbox_qc/:id',
		name: 'Xbox Qc',
		component: () => import('@/pages/packages/xbox/qc_xbox.vue'),
		meta: {
			label: 'Qc Xbox',
			icon: 'play_arrow',
			description: `QC Packag xbox à la norme Movielabs`,
			disabled: true
		}
	},
	{
		path: 'canal+Package/:id',
		name: 'Canal+ Package',
		component: () => import('@/pages/packages/canal+_package/canal+_package.vue'),
		meta: {
			label: 'Canal+ Package Form',
			icon: 'view_quilt',
			description: '',
			disabled: true
		}
	},
	{
		path: 'm6Package/:id',
		name: 'M6 Package',
		component: () => import('@/pages/packages/m6_package/m6_package.vue'),
		meta: {
			label: 'M6 Package Form',
			icon: 'view_quilt',
			description: '',
			disabled: true
		}
	}
]



// WEBPACK FOOTER //
// ./src/router/routes_packages.js